<template>
  <div class="bg-white container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="1">
        <div class="f box">
          <span class="label">用户ID：</span>
          <span class="info">{{ base_info.userId }}</span>
        </div>
        <div class="f box">
          <span class="label">用户名：</span>
          <span class="info">{{ base_info.fullName }}</span>
        </div>
        <div class="f box">
          <span class="label">邮箱/手机号：</span>
          <span class="info">{{ base_info.showName }}</span>
        </div>
        <!-- <div class="f box">
          <span class="label">用户标签：</span>
          <span class="info">{{base_info.}}</span>
        </div> -->
        <div class="f box">
          <span class="label">资质认证：</span>
          <span class="info">{{ !base_info.approvalStatus ? '-' : base_info.approvalStatus === 0 ? '未认证' :
            base_info.approvalStatus === 1 ? '审核中' : base_info.approvalStatus === 2 ? '认证失败' : '已认证' }}</span>
        </div>
        <div class="f box">
          <span class="label">是否绑定店铺：</span>
          <span class="info">{{ base_info.ifBindStore === 0 ? '否' : '是' }}</span>
        </div>
        <div class="f box">
          <span class="label">是否自动付款：</span>
          <span class="info">{{ base_info.ifAutomaticPayment === 0 ? '否' : '是' }}</span>
        </div>
        <div class="f box">
          <span class="label">用户分组：</span>
          <span class="info">{{ getGroupName(base_info.userGroup) }}</span>
        </div>
        <div class="f box">
          <span class="label">来源：</span>
          <span class="info">{{ base_info.userSource }}</span>
        </div>
        <div class="f box">
          <span class="label">注册时间：</span>
          <span class="info">{{ base_info.registerDate | dateFormat }}</span>
        </div>
        <div class="login-history">
          <span>登录历史：</span>
          <div class="history f" v-for="(item, index) in historyInfo" :key="index">
            <div class="left-icon">
              <i class="iconfont icon-computer-line"
                v-if="!item.equipmentType || item.equipmentType.indexOf('Windows') > -1"></i>
              <i class="iconfont icon-tablet-line" v-else></i>
            </div>
            <div>
              <div class="device_name">{{ item.equipmentType }} </div>
              <div class="info">IP: {{ item.ipAddress }}; {{ item.loginDate | dateFormat }}</div>
              <div class="info"><i class="iconfont icon-diqiuquanqiu"
                  v-show="item.loginAddress && item.loginAddress !== ''"></i> {{ item.loginAddress }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="资质信息" name="2" class="f-b">
        <div>
          <div class="certificate-box fd-c f-c-c">
            <img v-if="certificateForm.approvalStatus === 3" src="@/assets/img/certificated.svg" alt="">
            <img v-if="certificateForm.approvalStatus === 1" src="@/assets/img/certificating.svg" alt="">
            <img v-if="certificateForm.approvalStatus === 2" src="@/assets/img/certificate-fail.svg" alt="">
            <img v-if="certificateForm.approvalStatus === 0" src="@/assets/img/uncertificate.svg" alt="">
            <p v-show="certificateForm.approvalStatus === 0">UNVERIFIED BUYER</p>
            <p v-show="certificateForm.approvalStatus === 3">Authenticated Buyer</p>
            <p v-show="certificateForm.approvalStatus === 1">Under Review</p>
            <p v-show="certificateForm.approvalStatus === 2">Audit failure</p>
          </div>
          <div class="f box">
            <span class="label">First Name：</span>
            <span class="info">{{ certificateForm.first }}</span>
          </div>
          <div class="f box">
            <span class="label">Last Name：</span>
            <span class="info">{{ certificateForm.last }}</span>
          </div>
          <div class="f box">
            <span class="label">Seller Permit Numbe：</span>
            <span class="info">{{ certificateForm.sellerPermit }}</span>
          </div>
          <div class="f box">
            <span class="label">Company Name：</span>
            <span class="info">{{ certificateForm.companyName }}</span>
          </div>
          <div class="f box">
            <span class="label">Do you sell online：</span>
            <div>
              <span class="info">{{ certificateForm.ifSellOnline === 0 ? '否' : '是' }}</span><br>
              <span>{{ certificateForm.storeUrl }}</span>
            </div>
          </div>
          <div class="f box">
            <span class="label">Store Picture： </span>
            <el-image fit="contain" v-if="certificateForm.storePicture && certificateForm.storePicture !== ''"
              style="width:104px;height:104px;" :src="certificateForm.storePicture"
              :preview-src-list="[certificateForm.storePicture]"></el-image>
          </div>
          <div class="f box">
            <span class="label">Document of Proof：</span>
            <div class="f" style="margin:10px 0">
              <div v-for="(item, index) in documentFiles" :key="index" class="upload-demo-box">
                <div class="storePicture pointer fd-c f-c-c">
                  <img v-if="item.type === 'docx'" src="@/assets/img/word.png" alt="" @click="seeDocument(item.url)">
                  <img v-else-if="item.type === 'gif'" src="@/assets/img/GIF.png" alt="" @click="seeDocument(item.url)">
                  <img v-else-if="item.type === 'pdf'" src="@/assets/img/Pdf.png" alt="" @click="seeDocument(item.url)">
                  <el-image v-else-if="item.url && item.url !== ''" fit="contain" style="width: 63px; height: 63px"
                    :src="item.url" :preview-src-list="[item.url]">
                  </el-image>
                  <div>点击查看</div>
                </div>
              </div>
            </div>
          </div>
          <div class="f box">
            <span class="label">Address：</span>
            <span class="info">{{ certificateForm.address }}</span>
          </div>
          <div class="f box">
            <span class="label">City：</span>
            <span class="info">{{ certificateForm.city }}</span>
          </div>
          <div class="f box">
            <span class="label">State/Province：</span>
            <span class="info">{{ certificateForm.stateOrProvince }}</span>
          </div>
          <div class="f box">
            <span class="label">ZIP/Postal Code：</span>
            <span class="info">{{ certificateForm.ipOrPostalCode }}</span>
          </div>
          <div class="f box">
            <span class="label">Country：</span>
            <span class="info">{{ certificateForm.country }}</span>
          </div>
          <div class="f box">
            <span class="label">Phone：</span>
            <span class="info">{{ certificateForm.phone }}</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="店铺信息" name="3">
        <div class="f fw-w">
          <div class="store-box" v-for="item in storeList" :key="item.id">
            <div class="store-card">
              <div class="plat-img">
                <img v-if="item.platformCode === 'SP'" style="width:100%" src="@/assets/img/store-logo/shopify.png"
                  alt="" />
                <img v-if="item.platformCode === 'DJ'" style="width:100%" src="@/assets/img/store-logo/shoplazza.png"
                  alt="" />
                <img v-if="item.platformCode === 'SL'" style="width:100%" src="@/assets/img/store-logo/shopline.png"
                  alt="" />
                <img v-if="item.platformCode === 'WC'" style="width:100%" src="@/assets/img/store-logo/woocommerce.png"
                  alt="" />
              </div>
              <div class="store-info">
                <div class="store-title">
                  <i class="iconfont icon-store-line"></i>
                  <span>{{ item.storeName }}</span>
                  <div>
                    <el-row :gutter="24">
                      <el-col :span="8">
                        <p v-if="item.authorizeStatus === 0">Unauthorized</p>
                        <p v-else>Authorized</p>
                      </el-col>
                      <el-col :span="4" :offset="12">
                        <el-button type="text" @click="getStoreSetting(item.storeId)">详情</el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="资金信息" name="4">
        <div class="f box">
          <span class="label">余额:</span>
          <span class="info">{{ userFundInfo.balance }}</span>
        </div>
      </el-tab-pane>
      <el-tab-pane label="商业信息" name="5">
        <div class="f box">
          <registerQuestion :questionnaire_answers="questionnaireAnswers"></registerQuestion>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="交易信息" name="4">交易信息</el-tab-pane> -->
    </el-tabs>

    <el-dialog title="店铺设置" :visible.sync="storeDatailVisible">
      <storeSetting :storeId="storeId"></storeSetting>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import storeSetting from './components/StoreSetting.vue'
import registerQuestion from './components/RegisterQuestion.vue'
export default {
  data() {
    return {
      activeName: '1',
      base_info: {},
      storeList: [],
      certificateForm: {},
      group: [],
      historyInfo: [],
      documentFiles: [],
      storeDatailVisible: false,
      userFundInfo: {},
      storeId: '',
      questionnaireAnswers: undefined
    }
  },
  components: {
    storeSetting, registerQuestion
  },
  computed: {
    getGroupName() {
      return (code) => {
        let arr = this.group.filter(item => item.code === code)
        if (arr.length && arr.length > 0) {
          return arr[0].name
        }
      }
    },
  },
  created() {
    this.getUserCertification()
    this.getUserDetail()
    this.getStoreList()
    this.getAllUserGroup()
    this.getLoginLogs()
    this.getUserFundInfo()
  },
  methods: {
    getAllUserGroup() {
      API.getAllUserGroup().then(res => {
        this.group = res.data
      })
    },
    handleClick(tab, event) {
      console.log(tab);
    },
    getUserCertification() {
      API.getUserCertification(this.$route.query.id).then(res => {
        this.certificateForm = res.data || {}
        res.data && res.data.documentOfProofUrl && res.data.documentOfProofUrl.split(',').forEach((item, index) => {
          this.documentFiles[index] = { url: item, type: item.split('.')[item.split('.').length - 1] }
        })
      })
    },
    getUserDetail() {
      API.getUserDetail(this.$route.query.id).then(res => {
        this.base_info = res.data || {}
        if (this.base_info.questionnaireAnswers) {
          this.questionnaireAnswers = JSON.parse(this.base_info.questionnaireAnswers)
        }
      })

    },
    getStoreList() {
      API.getStoreList(this.$route.query.id).then(res => {
        this.storeList = res.data || []
      })
    },
    getStoreSetting(storeId) {
      this.storeId = storeId
      this.storeDatailVisible = true
    },
    getLoginLogs() {
      API.getLoginLogs(this.$route.query.id).then(res => {
        let timeNow = new Date().getTime()
        this.historyInfo = res.data.filter(item => { return item.loginDate > timeNow - 30 * 24 * 60 * 60 * 1000 })
      })
    },
    seeDocument(url) {
      window.open(url)
    },
    getUserFundInfo() {
      API.getBalance(this.$route.query.id).then(res => {
        this.userFundInfo = res.data || {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.storePicture {
  width: 104px;
  height: 110px;
  border: 1px dashed #c0ccda;
  position: relative;

  img {
    height: 63px;
    width: 63px;
  }

  text-align: center;
}

.upload-demo-box {
  margin-right: 15px;
  border-radius: 4px;
}

.container {
  padding: 10px 20px;
  min-height: calc(100vh - 60px);
}

.box {
  line-height: 32px;

  span {
    font-size: 14px;
    color: #a6aaa9;
  }

  .label {
    width: 160px;
    text-align: right;
    margin-right: 10px
  }
}

.login-history {
  margin-top: 60px;
  padding-left: 30px;

  span {
    font-size: 14px;
    color: #a6aaa9;
  }

  .history {
    width: 400px;
    padding: 10px 15px 20px;
    margin-left: 60px;
    border-bottom: 1px solid #cacbcb;

    .left-icon {
      width: 23px;
      height: 23px;
      margin-right: 12px;

      i {
        font-size: 22px;
      }
    }

    .device_name {
      color: #99c41c;
      font-size: 14px;
      padding-bottom: 10px;

      span {
        color: #2e373e;
        background: #99c41c;
        display: inline-block;
        width: 120px;
        height: 24px;
        border-radius: 12px;
        text-align: center;
        line-height: 24px;
      }
    }

    .info {
      font-size: 14px;
      line-height: 18px;
      color: #2e373e;
    }
  }
}

.store-box {
  // float: left;
  margin-right: 20px;
  margin-bottom: 10px;
  min-width: 360px;
  max-width: 420px;

  span {
    font-size: 14px;
    line-height: 20px;
  }
}

.store-card {
  width: 100%;
  height: 122.4px;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 12px 25px;
}

.plat-img {
  width: 120px;
  height: 40px;
}

.store-info {
  margin-top: 10px;
  margin-bottom: 10px;
}

.store-title {
  font-size: 14px;
  line-height: 20px;

  p {
    padding-top: 10px;
    color: #8b93a3;
  }
}

.certificate-box {
  width: 159px;
  height: 113px;
  margin: 0 0 20px 50px;
  border: 0.5px solid #e53238;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding-top: 10px;
  }
}
</style>